export default {
      id: "sentiment-operator-positive-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#sentiment-operator-positive-usage",
      toString: function () {
        return this.url;
      }
    }